const drinks = [
  {
    category: "Traditional",
    name: "House Coffee",
    info: "",
    price: 4,
  },
  {
    category: "Traditional",
    name: "Espresso",
    info: "",
    price: 4,
  },
  {
    category: "Traditional",
    name: "Americano",
    info: "",
    price: 4,
  },
  {
    category: "Traditional",
    name: "Cappuccino",
    info: "",
    price: 5,
  },
  {
    category: "Traditional",
    name: "Latte",
    info: "",
    price: 5.5,
  },
  {
    category: "Traditional",
    name: "Cold Brew",
    info: "",
    price: 5.5,
  },
  {
    category: "House Specials",
    name: "1987 (Iced)",
    info: "Hazelnut iced coffee sweetened with condensed milk, topped with sea salt cream & Ibarra chocolate",
    price: 6,
  },
  {
    category: "House Specials",
    name: "Vietnamese Iced Coffee",
    info: "Espresso sweetened with condensed milk, served over ice",
    price: 5.5,
  },
  {
    category: "House Specials",
    name: "Vietnamese Hazelnut",
    info: "Espresso sweetened with a salted hazelnut condensed milk, served over ice with a splash of half and half",
    price: 6,
  },
  {
    category: "House Specials",
    name: "18 to the brain",
    info: "Quad shot sweetened with condensed milk & shaken",
    price: 6.2,
  },
  {
    category: "House Specials",
    name: "Yuan Yang (YY)",
    info: "Espresso in a blend of black tea sweetened with condensed milk",
    price: 6.2,
  },
  {
    category: "House Specials",
    name: "Drax Thai Tea (Iced)",
    info: "Espresso floated in a Thai Tea",
    price: 6.2,
  },
  {
    category: "House Specials",
    name: "Sea Salt Cream Iced Coffee",
    info: "Sweetened iced coffee & Himalayan Sea Salt Cream",
    price: 5,
  },
  {
    category: "House Specials",
    name: "Caramel Sea Salt Cold Brew",
    info: "Caramel sweetened cold brew topped with sea salt cream",
    price: 6,
  },
  {
    category: "Mochas",
    name: "Mocha",
    info: "Ghirardelli & Ibarra chocolate, espresso and milk",
    price: 6.2,
  },
  {
    category: "Mochas",
    name: "Mexican Mocha",
    info: "Mocha with cinnamon & cayenne",
    price: 6.2,
  },
  {
    category: "Mochas",
    name: "Mocha Thai",
    info: "Mocha with condensed milk",
    price: 6.2,
  },
  {
    category: "Mochas",
    name: "White Mocha",
    info: "",
    price: 6.2,
  },
  {
    category: "Special Lattes",
    name: "Ube Latte (Iced)",
    info: "Ube jam sweetened with condensed milk, floated espresso shots",
    price: 6.2,
  },
  {
    category: "Special Lattes",
    name: "The Graham",
    info: "Honey, cinnamon, and vanilla syrup",
    price: 6.2,
  },
  {
    category: "Special Lattes",
    name: "Honey Lavender",
    info: "Honey with lavender syrup",
    price: 6.2,
  },
  {
    category: "Special Lattes",
    name: "Caramel Dream",
    info: "Caramel & vanilla syrup",
    price: 6.2,
  },
  {
    category: "Special Lattes",
    name: "Rose Latte",
    info: "Sweetened with rose syrup",
    price: 6.2,
  },
  {
    category: "Special Lattes",
    name: "Charcoal Latte",
    info: "Vanilla latte with activated charcoal",
    price: 6.2,
  },
  {
    category: "Tea Lattes",
    name: "Kloud 18",
    info: "Honey sweetened chamomile tea with soy milk",
    price: 6,
  },
  {
    category: "Tea Lattes",
    name: "London Fog",
    info: "Honey sweetened Earl Grey tea with milk",
    price: 6,
  },
  {
    category: "Tea Lattes",
    name: "Mighty Mint",
    info: "Honey sweetened Moroccan mint tea with milk",
    price: 6,
  },
  {
    category: "Tea Lattes",
    name: "Zen",
    info: "Honey sweetened jasmine tea with soy milk",
    price: 6,
  },
  {
    category: "Tea Lattes",
    name: "Tumi",
    info: "Honey sweetened turmeric tea blend with almond milk",
    price: 6,
  },
  {
    category: "Tea Lattes",
    name: "Chai Latte",
    info: "North Fork Chai",
    price: 6,
  },
  {
    category: "Tea Lattes",
    name: "Dirty Chai",
    info: "Chai latte with espresso",
    price: 6.2,
  },
  {
    category: "Tea Lattes",
    name: "Chocolate Chai",
    info: "North Fork Chai with chocolate",
    price: 6,
  },
  {
    category: "Tea Lattes",
    name: "Thai Iced Tea",
    info: "Sweetened black tea with half & half",
    price: 5.5,
  },
  {
    category: "Matcha",
    name: "Matcha Latte",
    info: "Matcha sweetened with vanilla",
    price: 6,
  },
  {
    category: "Matcha",
    name: "Strawberry Matcha (Iced)",
    info: "Matcha with strawberry syrup",
    price: 6,
  },
  {
    category: "Matcha",
    name: "Matcha Lemonade",
    info: "",
    price: 6,
  },
  {
    category: "House Iced Tea",
    name: "Blue Lady",
    info: "Blue mallow, grapefruit, citrus black tea",
    price: 5,
  },
  {
    category: "House Iced Tea",
    name: "Herbal",
    info: "Herbal Tisane with dried strawberry, apple, & kiwi",
    price: 5,
  },
  {
    category: "Loose Leaf Tea",
    name: "Green",
    info: "Jasmine, Moroccan mint",
    price: 5,
  },
  {
    category: "Loose Leaf Tea",
    name: "Black",
    info: "Earl grey, Assam, Ceylon",
    price: 5,
  },
  {
    category: "Loose Leaf Tea",
    name: "Oolong",
    info: "",
    price: 5,
  },
  {
    category: "Loose Leaf Tea",
    name: "Chamomile",
    info: "",
    price: 5,
  },
  {
    category: "Lemonade",
    name: "Charcoal Lavender Lemonade",
    info: "Lemonade with lavender syrup",
    price: 5,
  },
  {
    category: "Lemonade",
    name: "Herbal Lemonade",
    info: "Half lemonade and half herbal tea",
    price: 6,
  },
];

export default drinks;
